import { FEATURES } from "../config/features";

export const WorkflowStatus = {
  SENT: "Sent",
  DEPARTED: "Departed",
  NORECORD: "No Record",
  NOINCENTIVE: "No Incentive",

  PENDING: "Pending",
  STAGING: "Staging",
  PROCESSING: "Processing",
  ONBOARDING: "OnBoarding",
  ONGOING: "Ongoing",




  COMPLETED: "Completed",
  RELEASED: "Released",
  PROCESSED: "Processed",
  RECOMMENDED: "Recommended",
  NOTED: "Noted",
  APPROVED: "Approved",
  POSTED: "Posted",

  REJECTED: "Rejected",
  DISAPPROVED: "Disapproved",
  CANCELLED: "Cancelled",
  DECLINED: "Declined",
  NONE: "None",

  YES: "Yes",
  NO: "No",
};

const grayStatusStyle = {
  bgColor: 'bg-gray-100',
  textColor: 'text-gray-800',
  borderColor: 'border-gray-300',
  dotColor: 'bg-gray-500',
  ringColor: 'focus:ring-gray-400',
};

const greenStatusStyle = {
  bgColor: 'bg-green-100',
  textColor: 'text-green-800',
  borderColor: 'border-green-300',
  dotColor: 'bg-green-500',
  ringColor: 'focus:ring-green-400'
};

export const WorkflowStatusConfig = {
  [WorkflowStatus.SENT]: {
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    borderColor: 'border-yellow-300',
    dotColor: 'bg-yellow-500',
    ringColor: 'focus:ring-yellow-400'
  },
  [WorkflowStatus.PENDING]: {
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    borderColor: 'border-yellow-300',
    dotColor: 'bg-yellow-500',
    ringColor: 'focus:ring-yellow-400'
  },
  [WorkflowStatus.PROCESSING]: {
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    borderColor: 'border-blue-300',
    dotColor: 'bg-blue-500',
    ringColor: 'focus:ring-blue-400'
  },
  [WorkflowStatus.COMPLETED]: greenStatusStyle,
  [WorkflowStatus.RELEASED]: greenStatusStyle,
  [WorkflowStatus.PROCESSED]: {
    bgColor: 'bg-green-300',
    textColor: 'text-green-800',
    borderColor: 'border-green-300',
    dotColor: 'bg-green-500',
    ringColor: 'focus:ring-green-400'
  },
  [WorkflowStatus.ONGOING]: {
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    borderColor: 'border-green-300',
    dotColor: 'bg-green-500',
    ringColor: 'focus:ring-green-400'
  },
  [WorkflowStatus.CANCELLED]: {
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    borderColor: 'border-red-300',
    dotColor: 'bg-red-500',
    ringColor: 'focus:ring-red-400'
  },
  [WorkflowStatus.ONBOARDING]: {
    bgColor: 'bg-indigo-200',
    textColor: 'text-indigo-800',
    borderColor: 'border-indigo-300',
    dotColor: 'bg-indigo-500',
    ringColor: 'focus:ring-indigo-400'
  },
  [WorkflowStatus.RECOMMENDED]: {
    bgColor: 'bg-blue-200',
    textColor: 'text-blue-800',
    borderColor: 'border-blue-300',
    dotColor: 'bg-blue-500',
    ringColor: 'focus:ring-blue-400'
  },
  [WorkflowStatus.NOTED]: {
    bgColor: 'bg-blue-400',
    textColor: 'text-blue-900',
    borderColor: 'border-blue-300',
    dotColor: 'bg-blue-500',
    ringColor: 'focus:ring-blue-400'
  },
  [WorkflowStatus.APPROVED]: {
    bgColor: 'bg-emerald-100',
    textColor: 'text-emerald-800',
    borderColor: 'border-emerald-300',
    dotColor: 'bg-emerald-500',
    ringColor: 'focus:ring-emerald-400'
  },
  [WorkflowStatus.REJECTED]: { // Personnel usually uses "Rejected"
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    borderColor: 'border-red-300',
    dotColor: 'bg-red-500',
    ringColor: 'focus:ring-red-400'
  },
  [WorkflowStatus.NONE]: grayStatusStyle,
  [WorkflowStatus.DECLINED]: grayStatusStyle,
  [WorkflowStatus.NORECORD]: grayStatusStyle,
  [WorkflowStatus.NOINCENTIVE]: grayStatusStyle,
  [WorkflowStatus.DISAPPROVED]: {
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    borderColor: 'border-red-300',
    dotColor: 'bg-red-500',
    ringColor: 'focus:ring-red-400'
  },
  [WorkflowStatus.STAGING]: {
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    borderColor: 'border-yellow-300',
    dotColor: 'bg-yellow-500',
    ringColor: 'focus:ring-yellow-400'
  },
  [WorkflowStatus.POSTED]: {
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    borderColor: 'border-blue-300',
    dotColor: 'bg-blue-500',
    ringColor: 'focus:ring-blue-400'
  },
  [WorkflowStatus.DEPARTED]: {
    bgColor: 'bg-orange-300',
    textColor: 'text-orange-900',
    borderColor: 'border-orange-300',
    dotColor: 'bg-orange-500',
    ringColor: 'focus:ring-orange-400'
  },
  [WorkflowStatus.YES || WorkflowStatus.TRUE]: {
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    borderColor: 'border-green-300',
    dotColor: 'bg-green-500',
    ringColor: 'focus:ring-green-400'
  },
  [WorkflowStatus.NO || WorkflowStatus.FALSE]: {
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    borderColor: 'border-red-300',
    dotColor: 'bg-red-500',
    ringColor: 'focus:ring-red-400'
  },
  default: {
    bgColor: 'bg-gray-200',
    textColor: 'text-gray-600',
    borderColor: 'border-gray-200',
    dotColor: 'bg-gray-400',
    ringColor: 'focus:ring-gray-200'
  }
};

export const SALARYTYPES = {
  DAILY: "Daily",
  MONTHLY: "Monthly",
  ...(FEATURES.SALARY_TYPE_HAS_QOUTABASE && {
    QUOTABASED: "QuotaBased",
  }),
  // POSITIONDESIGNATION: "PositionDesignation",
  MAINTENANCESALARYCOMBINATION: "MaintenanceSalaryCombination",
}
export const IDENTIFIER = {
  EVERYCUTOFF: "Every Cutoff",
  FIRST: "First Cutoff",
  SECOND: "Second Cutoff"
};
export const CIVILSTATUS = {
  NONE: "None",
  SINGLE: "Single",
  MARIED: "Maried"
};
export const PARTIALSALARYSTATUS = {
  STAGING: "Staging",
  PROCESSED: "Processed",
}
export const SALARYADVANCETATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PENDING: "Pending",
  PROCESSING: "Processing",
  ONGOING: "Ongoing",
  APPROVED: "Approved",
  DISAPPROVED: "Disapproved",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
}
export const TAXABLESTATUS = {
  NONE: "None",
  TAXABLE: "Taxable",
  NONTAXABLE: "Non-Taxable"
};
export const ApprovalModules = { // New Way should be defined here, will be use this on the dropdown soon
  SALARY_ADVANCE: "SalaryAdvance", // this is the value that is being used now
  OVERTIME: "Overtime",
  LEAVE: "Leave",
};
export const LeaveIncentiveBatchStatus = {
  NORECORD: "No Record",
  NOINCENTIVE: "No Incentive",
  NOTQUALIFIED: "Not Qualified",
  PENDING: "Pending",
  COMPLETED: "Finalized"
};
export const StrategyTypes = {
  STANDARD: "Standard",
  AMOUNT_BASED: "AmountBased",
};
export const TAX_TREATMENT = {  // to remove, only used on old LeaveTypes.js
  DE_MINIMIS: 1,
  OTHER_BENEFITS_90K: 2,
  FULLY_TAXABLE: 3,
};
export const REQUEST_TYPES = {  // to remove, only used on old LeaveTypes.js
  LEAVE_REQUEST_ID: 1,
  CHANGE_SCHEDULE_REQUEST_ID: 2,
  OVERTIME_REQUEST_ID: 3,
  CHANGE_LOG_REQUEST_ID: 4,
  OFFSET_REQUEST_ID: 5,
  LEAVE_RECALL: 6,
};
export const TAX_TREATMENT_LABELS = { // to remove, only used on old LeaveTypes.js
  [TAX_TREATMENT.DE_MINIMIS]: "De Minimis",
  [TAX_TREATMENT.OTHER_BENEFITS_90K]: "Other Benefits (90k)",
  [TAX_TREATMENT.FULLY_TAXABLE]: "Fully Taxable",
};
export const LOAN_TYPES = {
  SSS_LOAN: "SSS Loan",
  SSS_EMERGENCY_LOAN: "SSS Emergency Loan",
  SSS_CALAMITY_LOAN: "SSS Calamity Loan",
  PAGIBIG_LOAN: "Pagibig Loan",
  PAGIBIG_CALAMITY_LOAN: "Pagibig Calamity Loan",
};

export const getStatusConfig = (status) => {
  if (!status) return WorkflowStatusConfig.default;

  // Find the key in WorkflowStatus that matches the string (case insensitive)
  const statusKey = Object.keys(WorkflowStatus).find(
    (key) => WorkflowStatus[key].toLowerCase() === status.toLowerCase()
  );

  return WorkflowStatusConfig[WorkflowStatus[statusKey]] || WorkflowStatusConfig.default;
};

export const DevModeStyle = "bg-green-300 text-green-800";
export const TestModeStyle = "bg-blue-300 text-blue-800";

// deprecated : we will utilize the filter ids from the backend instead of hardcoding it here, this is just for reference
// need to update the depencies of this shit
export const CommonFilterIds = {
  LOCATION: 1,
  COMPANY: 2,
  CLASSIFICATION: 3,
  EMPLOYMENT: 4,
  DEPARTMENT: 5,
  SECTION: 6,
  PAY_TYPE: 7,
  //SHIFT_SCHEDULE: 8,
  POSITION: 9,
  //SALARY_TYPE: 10,
  JOB_TITLE: 11,
  EMPLOYEE_GROUP_1: 12,
  EMPLOYEE_GROUP_2: 13,
  CLIENT: 14,
  VESSEL: 15,
  EMPLOYEE_TYPE: 16,
};